import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import bankService from '../services/bankService';

const BankTransactionFormPage = () => {
  const { accountId } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    bank_account_id: accountId,
    transaction_type: 'giris',
    amount: '',
    description: '',
    transaction_date: new Date().toISOString().split('T')[0]
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await bankService.createTransaction(formData);
      toast.success('Banka hareketi eklendi.');
      navigate(`/banks/detail/${accountId}`);
    } catch (error) {
      toast.error(error.response?.data?.message || 'İşlem başarısız.');
    }
  };

  return (
    <div className="container-fluid mt-4">
      <div className="card shadow-sm" style={{ maxWidth: '600px', margin: '0 auto' }}>
        <div className="card-header bg-white">
          <h4 className="mb-0">Yeni Banka Hareketi</h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">İşlem Tipi</label>
              <select name="transaction_type" className="form-select" value={formData.transaction_type} onChange={handleChange}>
                <option value="giris">Para Girişi</option>
                <option value="cikis">Para Çıkışı</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">Tutar (TL)</label>
              <input type="number" name="amount" className="form-control" value={formData.amount} onChange={handleChange} required min="0" step="0.01" />
            </div>
            <div className="mb-3">
              <label className="form-label">Tarih</label>
              <input type="date" name="transaction_date" className="form-control" value={formData.transaction_date} onChange={handleChange} required />
            </div>
            <div className="mb-3">
              <label className="form-label">Açıklama</label>
              <textarea name="description" className="form-control" rows="3" value={formData.description} onChange={handleChange} required></textarea>
            </div>
            <div className="d-flex justify-content-end">
              <button type="button" onClick={() => navigate(`/banks/detail/${accountId}`)} className="btn btn-secondary me-2">İptal</button>
              <button type="submit" className="btn btn-primary">Kaydet</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BankTransactionFormPage;